import * as h2Api from '../../h2Api'
import * as profileActions from '../../actions/majors'
import { handleReducingJournalForItem } from '../../actions'
import { POPUP_JOURNAL_COMPLETION } from '../../actions/journals'

const initialState = {
  selectedProfile: null,
  profileCache: {},
  localOpportunitiesLoading: false,
  selectedLocalTab: 5
}
const occupationProfile = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.CLEAR_SELECTION:
      return initialState

    case profileActions.RATE_MAJOR:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedProfile: {
            ...state.selectedProfile,
            personalization: action.restCall.result
          }
        }
      }

      return state

    case POPUP_JOURNAL_COMPLETION:
      return handleReducingJournalForItem(action, state, 'selectedProfile')

    case profileActions.MAJOR_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedProfile: p
        }
      }

      return state

    case profileActions.LOCAL_LOADING:
      return {
        ...state,
        localOpportunitiesLoading: true
      }

    case profileActions.LOCAL_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedLocalTab: action.selectedLocalTab,
          localOpportunitiesLoading: false,
          selectedProfile: {
            ...state.selectedProfile,
            localOpportunities: p
          }
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.ERROR) {
        return {
          ...state,
          localOpportunitiesLoading: false
        }
      }

      return state

    default:
      return state
  }
}

export default occupationProfile
